import PUserAccountRecoveryComponent from '@/components/pages/oweb/PUserAccountRecovery.vue';
import { OWebPageBase } from 'oweb';
import { VueConstructor } from 'vue';

export default class PUserAccountRecovery extends OWebPageBase<VueConstructor> {
	getName() {
		return 'PUserAccountRecovery'
	}

	getRoutes() {
		return [
			{
				title: 'OO_LANG_ACCOUNT_RECOVERY',
				path: '/me/recover'
			},
			{
				title: 'OO_LANG_ACCOUNT_RECOVERY',
				path: '/me/recover/:step',
				pathOptions: {
					step: /one|two|three/
				}
			} ]
	}

	getComponent() {
		return PUserAccountRecoveryComponent;
	}
}